module.exports = __webpack_public_path__ + "static/media/34.9f1a0317.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/34.svg
// module id = 2825
// module chunks = 3